import { render } from "./AuthLayout.vue?vue&type=template&id=54947a21&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&lang=ts"

import "./AuthLayout.vue?vue&type=style&index=0&id=54947a21&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54947a21"

export default script